module.exports = __webpack_public_path__ + "static/img/card4a.787c109.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/card4a.jpg
// module id = xbLr
// module chunks = 1